import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';

export class HttpErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          debugger;
          let errMsg = '';
          if (error.status === 401) {
            errMsg = `Error Code: ${error.status},  Message: User Not Authorization`;
            return _throw(errMsg);

            // auto logout if 401 response returned from api
            // this.authenticationService.logout();
            // location.reload(true);
          }
          // Client Side Error
          if (error.error instanceof ErrorEvent) {
            errMsg = `Error: ${error.error.message}`;
          }
          else {  // Server Side Error
            errMsg = `Error Code: ${error.status},  Message: ${error.statusText}`;
          }
          return _throw(errMsg);
        })
      )
  }
}  



// WEBPACK FOOTER //
// ./src/app/helpers/http-error.ts